import { useState } from "react";

import { makePostApiCall } from "../../shared/makeApiCall";
import DeleteConfirmationForm from "../../components/forms/DeleteConfirmationForm";
import { SnackbarData, SnackbarType } from "../../components/Snackbar";
import { generateUniqueNumber } from "../../shared/utility";

export function RecipesViewModel(logout, addSnackbar) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [recipes, setRecipes] = useState({ data: [] });
  const [fetchedRecipe, setFetchedRecipe] = useState({});
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });

  const getRecipes = async function (search, page) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
    };
    let callResult = await makePostApiCall(`recipes`, payload);
    setLoading(false);
    if (callResult.success) {
      setRecipes(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const fetchRecipeByPlu = async function (plu) {
    if (!plu) return;
    const callResult = await makePostApiCall(`fetchRecipeByPLU/${plu}`, {});
    if (callResult.success) {
      setFetchedRecipe(callResult.data);
    } else if (callResult.errorStatus === 401) {
      logout();
    }
  };

  const deleteRecipe = async function (id) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteRecipe/${id}`, {});
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });
      getRecipes(null, 0);
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success,
        ),
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteRecipe = function (recipe) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteRecipe(recipe.id)}
          message={`Are you sure you want to delete  ${recipe.recipe_name}?`}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  };

  return {
    askDeleteRecipe,
    emptyModal,
    fetchRecipeByPlu,
    fetchedRecipe,
    getRecipes,
    loading,
    recipes,
    setEmptyModelOpen,
    setSlideOver,
    slideOver,
  };
}
